import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE,
});

export const apiv4 = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_V4,
});